<div class="stripe-form stripe-form-modal">
  <div class="container-fluid">
    <div class="row">
      <div class="col">
        <div class="main-title-ucx">
          <h5 class="font-weight-bold">Add a New Credit Card</h5>
          <div class="line"></div>
        </div>
      </div>
    </div>
  </div>

  <!-- Stripe Form -->
  <form (ngSubmit)="onSubmit()" [formGroup]="stripeForm">
    <div class="container-fluid">
      <div class="row">
        <div class="col-12">
          <!-- Full Name -->
          <div class="form-group">
            <label>Card Holder Name</label>
            <input autocomplete="off" class="form-control" formControlName="name" placeholder="Card Holder Name"
                   type="text">
            <span *ngIf="tooltipService.getState('name')">
              <app-tooltip
                [errorMessages]="tooltipService.inputValidation('name', defaultRequired, defaultExists, defaultInvalid)"
                [position]="'below'"
                [fieldName]="'Card Holder Name'">
              </app-tooltip>
            </span>
          </div>
        </div>
<!--        <div class="col-12">-->
<!--          &lt;!&ndash; Card Number &ndash;&gt;-->
<!--          <div class="form-group">-->
<!--            <label>Card Number*</label>-->
<!--            <div class="field" id="card-number"></div>-->
<!--          </div>-->
<!--        </div>-->
      </div>
      <div class="row">
        <ngx-stripe-card

          [elementsOptions]="elementsOptions"
        ></ngx-stripe-card>
      </div>

      <div class="row align-items-center">
        <!-- todo: after release implement it
        <div class="col-xl-10">
            <div class="form-check">
                <input class="form-check-input" type="checkbox" id="confirm" (click)="onCheckBoxClicked()">
                <label class="form-check-label" for="confirm">
                    Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.
                </label>
            </div>
        </div>
        -->
        <div class="col">
          <button [disabled]="confirmBtnDisabled" class="btn-default" type="submit">
            Confirm
          </button>
        </div>
      </div>
    </div>
  </form>
</div>
